<script lang="ts">
	import PriceCard from '../parts/landingPages/priceCard.svelte';
	import Affirm from '$lib/icons/affirm.svelte';
	import Info from '$lib/icons/info.svelte';
	import Modal from '$lib/modal/v2/modal.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import AffirmModalContent from '$lib/modals/bnplModal/affirmModalContent.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			price: string;
			interval: string;
		}>['content'];
	}

	let { content }: Props = $props();

	let affirmModal = $state<{ show: () => void; hide: () => void }>();
</script>

<div use:editable={content}>
	<PriceCard title={content.title} interval={content.interval} price={content.price}>
		{#snippet subline()}
			<p class="text-[16px]/[140%] text-brown-3 lg:text-[18px]">
				Finance with <Affirm class="mx-2 -mt-1 inline w-[45px] lg:w-[49px]" /> for as low as
				<button onclick={affirmModal?.show}
					><Info class="-mt-1 ml-2 inline h-6 w-6 text-brown-2" /></button
				>
			</p>
		{/snippet}
	</PriceCard>
</div>

<Modal
	withDesktopPadding
	size="regular"
	class="max-h-[67vh] lg:max-h-[67vh] lg:w-1/2 2xl:max-h-[75vh]"
	bind:this={affirmModal}
	modalName="Affirm Modal"
>
	<AffirmModalContent />
</Modal>
